const THREE = window.THREE;


class PlaceState {
    constructor( app, options) {
        this.app = app;
        this.options = options;

        this.tempVec3 = new THREE.Vector3();
        this.tempQut = new THREE.Quaternion();

        this.testDist = true;
    }

    enter(){

        let sphereGeometry = new THREE.SphereBufferGeometry( 0.008, 0.008, 0.008);
        let sphereMaterial = new THREE.MeshBasicMaterial( { color: 0xff0000 } );
        let sphere = new THREE.Mesh( sphereGeometry, sphereMaterial );
        this.app.scene.add( sphere );
        this.point = sphere;
        this.zhenweiReady = false;
        this.raycaster = new THREE.Raycaster();

        this.renti = this.app.loader.models['renti.glb'];
        this.renti.visible = true;

        let zhen = this.app.loader.models["yinzhen.glb"];
        zhen.visible = false;
        this.zhen = zhen.clone();
        
        this.app.scene.add( this.zhen );

        let aijiu = this.app.loader.models["aiji_1.glb"];
        aijiu.visible =false;
        this.aijiu = aijiu.clone();

        this.app.setRentiRotate('up');
        this.placeindex = 0;

        this.placedObjs = {};
    }


    onClick(event)
    {
        let intro = this.check( true );

        if( !intro ) return;

        //拷贝当前point
        if( this.addedPoints ) {
            this.addedPoints.position.copy( this.point.position );

        } else {
            let p = this.point.clone();
            this.addedPoints = p;
            this.app.scene.add( p );
        }
        
        this.app.distLine.updateStarPoint( this.addedPoints );
        window.Bus.emit("zhenweiReady");
    }

    check( adjust )
    {
        let raycaster = this.raycaster;

        raycaster.setFromCamera( this.app.mouse, this.app.activeCamera);

        let intersections = raycaster.intersectObjects( this.renti.children , true);

        if( intersections && intersections.length > 0 )
        {
            let intersection = intersections[0];
            this.point.position.copy( intersection.point );

            let p =  intersection.point
		
            this.tempVec3.copy( intersections[ 0 ].face.normal );
            let mesh = intersection.object;
			this.tempVec3.transformDirection( mesh.matrixWorld );
            // intersection.normal.copy( intersects[ 0 ].face.normal );
            this.tempVec3.multiplyScalar( -10 );
            this.tempVec3.add( p );
                        
            if( adjust )
            {
                this.zhen.position.copy( intersection.point );
                // this.zhen.quaternion.setFromUnitVectors(DefaultUp, intersection.face.normal)
                this.zhen.lookAt( this.tempVec3 );

                this.aijiu.position.copy( intersection.point );
                this.aijiu.lookAt( this.tempVec3 );
            }  
            return intersection;
        }
    }

    placeYinzhen(para){
        
        if( !this.addedPoints ) return;

        console.log( para );

        let thornType = para.thornType;
        let unit = para.unit;
        let posName = para.posName;

        let angle = 0;
        if( thornType == 1) {
            angle  = 45; 
        } else if( thornType == 2 ) {
            angle = 75;
        }
        // angle = 0;

        let q = new THREE.Quaternion();
        q.setFromAxisAngle(new THREE.Vector3(-1,0,0), angle* Math.PI / 180);
        if( posName.indexOf('qimen') > -1 ) {

            let rot = angle > 0 ? 45 : 0;
            if( rot != 0 && posName == 'qimen' ) {
                rot = -45;
            }
            q.setFromEuler(new THREE.Euler(angle* Math.PI / 180, rot * Math.PI / 180, 0));
        }

        let prePlaced =  this.placedObjs[posName];
        if( prePlaced && prePlaced.name == 'aijiu' ) {
            this.app.scene.remove( prePlaced );
            this.placedObjs[posName] = null;
            prePlaced = null;
            this.app.placedAijiu = null;
        }

        let zhen  =  prePlaced? prePlaced: this.zhen.clone();
        zhen.visible = true;
        zhen.name = 'zhen';
        zhen.placeName = posName;
       

        if( !this.app.placedYinzhen ) this.app.placedYinzhen = [];
        
        if( !prePlaced ) {
            this.placeindex +=1;
            zhen.placeOrder = this.placeindex;
            zhen.quaternion.multiply( q );
            this.app.placedYinzhen.push(zhen);

        } else {
            zhen.position.copy( this.zhen.position );
            zhen.quaternion.copy( this.zhen.quaternion );
            zhen.quaternion.multiply( q );
        }

        let zhenType = para.zhenType;
        //let zhenLength = parseInt(zhenType);
    
        let units = {
            '0.5':{base:0.04, unit:0.0015, size:13, total:0.5},
            '1':{base:0.02, unit:0.0015,size:25, total:1},
            '1.5':{base:0.0125, unit:0.0012, size:40, total:1.5},
            '2.5':{base:0.00833, unit:0.00083, size:60, total:2.5},
            '3':{base:0.0, unit:0.0008, size:75,total:3},
        }   
    
        let spec = units[zhenType];
        unit = unit / spec.total * spec.size;
        zhen.children[0].position.z = spec.base + (unit * spec.unit);
        console.log( zhen.children[0].position.z );

        if( !prePlaced ) {
            this.app.scene.add( zhen );
            this.placedObjs[posName] = zhen;
        }
        
        this.app.scene.remove( this.addedPoints );
        
        this.addedPoints = null;

        this.app.xueweis[posName].getWorldPosition( this.tempVec3 );
        
        let dist = zhen.position.distanceTo( this.tempVec3 );
        dist = dist * 1000;
        
        setTimeout(() => {
            console.log(posName, dist);
            window.Bus.emit("yinzhenPlaced", {posName, dist});
        }, 100);
    }
    
    placeAijiu(para){
        console.log(　"placeAijiu"　);
        if( !this.addedPoints ) return;
        let posName = para.posName;

        let obj = this.placedObjs[posName];
        if( obj && obj.name == 'zhen') {
            this.app.scene.remove( obj );
            this.placedObjs[posName] = null;
        }

        if( this.app.placedAijiu ) {
            this.app.placedAijiu.position.copy(this.aijiu.position);
            this.app.placedAijiu.quaternion.copy( this.aijiu.quaternion );

            this.placedObjs[posName] = this.app.placeAijiu;
            return;
        }
        
        let aijiu  = this.aijiu.clone();
        aijiu.visible = true;
        aijiu.name = 'aijiu';
        this.app.placedAijiu = aijiu;
        // let q = new THREE.Quaternion();
        // q.setFromAxisAngle(new THREE.Vector3(0,1,0), 45* Math.PI / 180);
        // aijiu.quaternion.multiply( q );
        this.app.scene.add( aijiu );
        
        this.app.scene.remove( this.addedPoints );
    
        this.addedPoints = null;

        this.placedObjs[posName] = aijiu;

        this.app.xueweis[posName].getWorldPosition( this.tempVec3 );
        
        let dist = aijiu.position.distanceTo( this.tempVec3 );
        dist = dist * 1000;

        setTimeout(() => {
            window.Bus.emit("aijiuPlaced", {posName,dist});
        }, 100);
    }

    exit()
    {
        this.app.scene.remove( this.point );
        if( this.addedPoints ) this.app.scene.remove( this.addedPoints );
        this.addedPoints = null;

        // this.point = sphere;
        this.app.distLine.changeVisible( 0 );
    }

    update(){
       let obj = this.check();
       if( obj ) {
           this.app.distLine.updateEndPoint( this.point );
       }
    }
}

export default PlaceState;